import { fs } from './base';

import { MutationArg } from 'v2/types';
import { FolderModel, FileModel } from 'v2/types/FileSystemModel';
import { SWRKeyValue } from 'v2/types/swr';

export const fileSystemService = {
  getRootFolders(): Promise<FolderModel[]> {
    return fs.get('v1/folder/root').json();
  },

  getFoldersBySearch([_key, search]: SWRKeyValue): Promise<FolderModel[]> {
    return fs.get(`v1/folder/${search}/folders`).json();
  },

  getFilesBySearch([_key, search]: SWRKeyValue): Promise<FileModel[]> {
    return fs.get(`v1/file/${search}/files`).json();
  },

  createFolder(
    _key: string,
    { arg }: MutationArg<Pick<FolderModel, 'name' | 'description' | 'parentId'>>
  ): Promise<FolderModel> {
    return fs.post('v1/folder', { json: arg }).json();
  },

  updateFolder(
    [_key, folderId]: SWRKeyValue,
    { arg }: MutationArg<Pick<FolderModel, 'name' | 'description' | 'parentId'>>
  ): Promise<FolderModel> {
    return fs.put(`v1/folder/${folderId}`, { json: arg }).json();
  },

  deleteFolder([_key, folderId]: SWRKeyValue): Promise<FolderModel> {
    return fs.delete(`v1/folder/${folderId}`).json();
  },

  getChildFolders([_key, parentFolderId]: SWRKeyValue): Promise<FolderModel[]> {
    return fs.get(`v1/folder/parent/${parentFolderId}/childs`).json();
  },

  getChildFiles([_key, parentFolderId]: SWRKeyValue): Promise<FileModel[]> {
    return fs.get(`v1/file/parent/${parentFolderId}/childs`).json();
  },

  uploadFilesToFolder([_key, folderId]: SWRKeyValue, { arg }: MutationArg<FormData>): Promise<FileModel[]> {
    return fs.post(`v1/file/${folderId}/upload`, { body: arg }).json();
  },

  updateFile([_key, fileId]: SWRKeyValue, { arg }: MutationArg<string>): Promise<FileModel> {
    return fs.put(`v1/file/${fileId}`, { json: { filename: arg } }).json();
  },

  deleteFile([_key, fileId]: SWRKeyValue): Promise<FileModel> {
    return fs.delete(`v1/file/${fileId}`).json();
  },
};
